import React, { useMemo } from 'react'
import classNames from 'classnames'
import Skeleton from 'react-loading-skeleton'
import { ReactSVG } from 'react-svg'
import { Tag } from '../server/utils/getArticlesData'
import Chip from './Chip'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import DateLabel from './DateLabel'
import { textMorph } from '../utils/textMorph'
import Favorite from './Favorite'

interface Props {
  loading?: boolean
  className?: string
  picture?: string
  title?: string
  favoriteHandler?: (value: boolean) => Promise<void>
  favorite?: boolean
  tags?: Tag[]
  titleTag?: React.ElementType
  to?: any
  startDate?: string
  renderFoot?: () => React.ReactElement | string
}

const ArticleCard: React.FC<Props> = ({
  loading = false,
  className = '',
  picture,
  title,
  favoriteHandler,
  favorite = false,
  tags = [],
  titleTag = 'h2',
  to = '#',
  startDate,
  renderFoot
}) => {
  const TitleTag = titleTag

  const parseStartDate = useMemo(() => {
    const date = {
      mouth: '',
      day: '',
      diff: ''
    }

    if (startDate) {
      const parseDate = dayjs(startDate),
        parseDateFormat = parseDate.format('MMM, DD')?.split(','),
        diff = parseDate.diff(dayjs(), 'days')

      date.mouth = parseDateFormat[0]?.slice(0, parseDateFormat[0]?.length - 1)
      date.day = parseDateFormat[1]
      date.diff = diff
        ? `Через ${diff} ${textMorph(diff, ['день', 'дня', 'дней'])}`
        : 'Сегодня'

      if (diff < 0) {
        date.diff = 'Прошло'
      }
    }

    return date
  }, [startDate])

  return (
    <article className={classNames('article-card', className)}>
      <div className={'article-card__picture'}>
        {loading ? (
          <Skeleton height={'100%'} width={'100%'}></Skeleton>
        ) : (
          <>
            <img src={picture} alt={title} />
            {startDate && (
              <DateLabel
                day={parseStartDate.day}
                mouth={parseStartDate.mouth}
              />
            )}
            {favoriteHandler ? (
              <Favorite value={favorite} handler={favoriteHandler}></Favorite>
            ) : null}
          </>
        )}
      </div>
      <div className={'article-card__inner'}>
        <div className={'article-card__content'}>
          {loading ? (
            <header className={'article-card__tags'}>
              <Skeleton height={'3rem'} width={'10rem'}></Skeleton>
            </header>
          ) : tags.length ? (
            <header className="article-card__header">
              <div className={'article-card__tags row row-gap-8'}>
                {tags.map((tag) => (
                  <Chip key={tag.label} color={tag.color}>
                    <>
                      {tag.icon ? (
                        <ReactSVG
                          src={tag.icon}
                          className={'svg-icon'}
                          wrapper={'span'}
                        ></ReactSVG>
                      ) : null}
                      <span>{tag.label}</span>
                    </>
                  </Chip>
                ))}
              </div>

              {startDate && (
                <div className="days-diff">
                  <ReactSVG
                    src={'/i/svg/alarm-plus.svg'}
                    className={'svg-icon'}
                    wrapper={'span'}
                  />
                  <span>{parseStartDate.diff}</span>
                </div>
              )}
            </header>
          ) : null}
          <TitleTag className={'article-card__title text-h4'}>
            {loading ? (
              <Skeleton count={2}></Skeleton>
            ) : (
              <Link to={to}>{title}</Link>
            )}
          </TitleTag>
        </div>

        {renderFoot ? (
          <footer className={'article-card__foot'}>{renderFoot()}</footer>
        ) : null}
      </div>
    </article>
  )
}

export default ArticleCard
